import { Controller } from "@hotwired/stimulus"
import { refreshTrixEditors } from "../utils/refresh_trix_editors"

// Connects to data-controller="conversation"
export default class extends Controller {
  static targets = ["header", "expanded"]

  static values = {
    conversationId: String
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const isExpanded = this.expandedTarget.style.display !== "none"
    
    if (isExpanded) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand() {
    this.expandedTarget.style.display = "block"
    this.headerTarget.classList.add("border-primary")
    refreshTrixEditors(this.expandedTarget)
    
    // Scroll to show the expanded conversation
    setTimeout(() => {
      this.expandedTarget.scrollIntoView({ behavior: "smooth", block: "nearest" })
    }, 100)
  }

  collapse() {
    this.expandedTarget.style.display = "none"
    this.headerTarget.classList.remove("border-primary")
  }
}

